import { Editor } from '@tiptap/react';
import classNames from 'classnames';

interface FloatingMenuProps {
    editor: Editor;
}

const FloatingMenu = ({ editor }: FloatingMenuProps) => {
    const MenuButton = ({ onClick, icon, title, label }: any) => (
        <div
            onClick={onClick}
            className={classNames(
                'flex items-center gap-2.5 w-full p-2.5 rounded-md transition-all duration-200',
                'text-content-500/80 dark:text-content-400/80',
                'hover:bg-content-100/50 dark:hover:bg-content-800/50',
                'hover:text-content-500 dark:hover:text-content-400',
            )}
            title={title}
        >
            <div className={classNames(icon, 'h-4 w-4')} />
            <span className="text-sm font-medium">{label}</span>
        </div>
    );

    return (
        <div className="flex flex-col gap-1 min-w-[180px] rounded-lg border border-content-100 dark:border-content-800 bg-base-200/95 dark:bg-content-600/95 p-1.5 shadow-lg backdrop-blur-sm">
            <MenuButton
                onClick={() => editor.chain().focus().toggleHeading({ level: 1 }).run()}
                icon="icon-[ph--text-h-one]"
                title="Heading 1"
                label="Heading 1"
            />
            <MenuButton
                onClick={() => editor.chain().focus().toggleHeading({ level: 2 }).run()}
                icon="icon-[ph--text-h-two]"
                title="Heading 2"
                label="Heading 2"
            />
            <MenuButton
                onClick={() => editor.chain().focus().toggleBulletList().run()}
                icon="icon-[ph--list-bullets]"
                title="Bullet List"
                label="Bullet List"
            />
            <MenuButton
                onClick={() => editor.chain().focus().toggleOrderedList().run()}
                icon="icon-[ph--list-numbers]"
                title="Ordered List"
                label="Ordered List"
            />
            <MenuButton
                onClick={() => editor.chain().focus().toggleCodeBlock().run()}
                icon="icon-[ph--code-block]"
                title="Code Block"
                label="Code Block"
            />
        </div>
    );
};

export default FloatingMenu; 